import React, { useState } from "react"
import { ProviderFinderParam, useStringSearchParam } from "#/pages/provider-finder/utils/providerFinderSearchUrl"
import { KeywordAutocomplete } from "../keyword-search/KeywordAutocomplete"
import { ForwardIcon, SearchIcon } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import { useProviderTypeSearched } from "#/pages/provider-finder/components/results/useProviderTypeSearched"

export function SidebarKeywordSearch(): JSX.Element {
  const [providerNameSearchValue, setProviderNameSearchValue] = useState(null)
  const [keyword, setKeyword] = useStringSearchParam(ProviderFinderParam.Keyword)
  const [, setSearch] = useStringSearchParam(ProviderFinderParam.Search)
  const [, setRadiusInKm] = useStringSearchParam(ProviderFinderParam.RadiusInKm)
  const intl = useIntl()

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setKeyword(providerNameSearchValue)
    setSearch("")
    setRadiusInKm("")
  }

  const { providerTypeId } = useProviderTypeSearched()

  return (
    <>
      <form onSubmit={handleSubmit}>
        <KeywordAutocomplete
          keyword={keyword}
          popupIcon={
            <ForwardIcon
              fontSize="medium"
              sx={(theme) => ({
                marginInlineStart: theme.spacing(theme.tokens.spacing.xxs),
                marginInlineEnd: theme.spacing(theme.tokens.spacing.xxs)
              })}
              onClick={handleSubmit}
            />
          }
          placeholder={intl.formatMessage({ defaultMessage: "Search" })}
          startAdornment={
            <SearchIcon
              fontSize="medium"
              sx={(theme) => ({
                color: theme.palette.text.disabled,
                marginInlineStart: theme.spacing(theme.tokens.spacing.xxs),
                marginInlineEnd: theme.spacing(theme.tokens.spacing.xxs)
              })}
            />
          }
          setProviderNameValue={setProviderNameSearchValue}
          sx={{
            ".MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent"
            },
            "& .MuiAutocomplete-popupIndicator": { transform: "none" }
          }}
          providerType={providerTypeId}
        />
      </form>
    </>
  )
}
